import { Controller } from "@hotwired/stimulus"

// Revela o elemento ao entrar no viewport (uso: data-controller="reveal").
// Escuta turbo:before-cache porque o snapshot do Turbo é clonado antes do
// disconnect(): sem forçar o estado final, restore visits voltariam invisíveis.
export default class extends Controller {
  static values = { threshold: { type: Number, default: 0.2 } }

  connect() {
    this.forceReveal = this.forceReveal.bind(this)
    document.addEventListener("turbo:before-cache", this.forceReveal)

    const reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (reduced || this.element.classList.contains("revealed")) {
      this.forceReveal()
      return
    }

    this.element.classList.add("reveal-start")
    this.observer = new IntersectionObserver(
      (entries) => {
        if (entries.some((entry) => entry.isIntersecting)) this.forceReveal()
      },
      { threshold: this.thresholdValue }
    )
    this.observer.observe(this.element)
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.forceReveal)
    this.observer?.disconnect()
    this.observer = null
  }

  forceReveal() {
    this.element.classList.add("revealed")
    this.observer?.disconnect()
    this.observer = null
  }
}
